module.exports = __webpack_public_path__ + "assets/9a8a6d91da2974f9a2172314ea5f714f.svg";